import { get, post } from '@/api/index';
export const submitAnswer = params => post(`/api/paper/v1/submit`, params); //试卷提交
